export default "__VITE_ASSET__BkzNHq1M__"